import { useContext } from 'react'

import MultiframeControlsProvider, {
  IMultiframeContextProps,
  MultiframeControlContext,
} from './Provider'

export { MultiframeControlsProvider, MultiframeControlContext }
export type { IMultiframeContextProps } from './Provider'

export const useMultiframeControls = (): IMultiframeContextProps =>
  useContext(MultiframeControlContext)
